import { render } from "./MailingList.vue?vue&type=template&id=944d523c&scoped=true"
import script from "./MailingList.vue?vue&type=script&lang=js"
export * from "./MailingList.vue?vue&type=script&lang=js"

import "./MailingList.vue?vue&type=style&index=0&id=944d523c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-944d523c"]])

export default __exports__